import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'
import { admin } from 'routes/route.map'

import AddMemberBankAccountComponent from './component'

export const AddMemberBankAccount = combine({
  hooks: [
    withContext(
      'adminMemberService',
      ServicesContext,
      ({ adminMemberService }) => adminMemberService
    ),

    withCallbacks(
      {
        onSubmit:
          ({ adminMemberService }, { history, match }) =>
          async (bankAccountDTO) => {
            const memberId = Number(match.params.memberId)
            await adminMemberService.addMemberBankAccount(
              memberId,
              bankAccountDTO
            )
            toaster.info('Member bank account has been successfully created')
            history.push(admin.sponsors.invoices.view(memberId))
          },
      },
      []
    ),
  ],
  transformProps: ({ match, onSubmit }) => {
    return {
      beneficiaryId: Number(match.params.beneficiaryId),
      onSubmit,
    }
  },
})(AddMemberBankAccountComponent)
